import SelectField from "controls/global/select-field";
import { getTitleSearchProductOptions } from "pages/file/utils/helper";
import React, { useMemo } from "react";
import { useWatch } from "react-hook-form";
import { useSpaceAgencyConfig } from "utils/context/SpaceContext";
import useFormWrapper from "utils/custom-hooks/useFormWrapper";

interface Props {
  schema: string;
  name: string;
  disabled?: boolean;
  onChange?: () => void;  
}

const ProductTypeField = ( {schema, name, disabled, onChange}:Props) => {
  const {setValue} = useFormWrapper();
  const [{ tsAgencyConfig }] = useSpaceAgencyConfig();

  // Watched, not read through getValues: the saved product can arrive after the first
  // render on file load, and the sibling Transaction/Property Type drive the filtering.
  const [
    currentTransactionType,
    currentPropertyTypeCode,
    savedProduct,
  ] = useWatch({
    name: [
      `${schema}.transactionType`,
      `${schema}.propertyTypeCode`,
      name,
    ],
  });

  const handleOnChange = async (e: any, value: any) => {
    setValue("isFileDefault", false);
    setValue("isTransTypeSelectedByUser", true);
    onChange && onChange();
  };

  // A saved product the config no longer offers comes back as a non-selectable option
  // rather than being cleared, so an ordered product never goes blank on screen.
  const tsProductTypes = useMemo(
    () =>
      getTitleSearchProductOptions(
        tsAgencyConfig,
        currentTransactionType,
        currentPropertyTypeCode,
        savedProduct
      ),
    [
      tsAgencyConfig,
      currentTransactionType,
      currentPropertyTypeCode,
      savedProduct,
    ]
  );

  return (
    <SelectField
      label="Product Type"
      name={name}
      options={tsProductTypes}
      disabled={disabled}
      onChange={handleOnChange}
    />
  );
}

export default ProductTypeField;